import { Box, CircularProgress, Stack, Typography } from "@mui/material"
import TableCell from "@mui/material/TableCell"
import TableRow from "@mui/material/TableRow"
import CircleIcon from "@mui/icons-material/Circle"
import dayjs from "dayjs"
import { useGetTimeSlotsQuery } from "../../../api/TimeSlotsApi"
import { useDispatch, useSelector } from "react-redux"
import { SelectedCellsPopup } from "../tableCell/SelectedCellPopup"
import React, { useEffect } from "react"
import {
  setSelectedDate,
  setSelectedTimeSlotState,
  setSelectedfullName,
  setSelecteduserId,
} from "../../create/dialogs/model/SelectedTimeSlot"
import { keycloakInstance } from "../../../../../shared/libs/keycloack/config"
import NoRowsOverlay from "../../../../../shared/ui/NoRowsOverlay"
import { useLocation } from "react-router-dom"

const TimeSlotsRow = ({ open, setOpen }: any) => {
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const graphType = queryParams.get("graphType")
  const interviewer = queryParams.get("interviewer")

  const currentWeek = useSelector(
    (state: any) => state.weekPagination.currentWeek,
  )

  const startOfWeek = dayjs.utc(currentWeek).startOf("week")
  const endOfWeek = dayjs.utc(currentWeek).endOf("week")

  let query = `startOfWeek=${startOfWeek.format(
    "YYYY-MM-DDTHH:mm:ss[Z]",
  )}&endOfWeek=${endOfWeek.format(
    "YYYY-MM-DDTHH:mm:ss[Z]",
  )}&graphType=${graphType}&interviewer=${interviewer}`

  const { data, error, isLoading, refetch } = useGetTimeSlotsQuery(query, {})

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null)
  const dispatch = useDispatch()

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget)
  }

  if (error) {
    return <TableRow>{JSON.stringify(error)}</TableRow>
  }

  if (isLoading) {
    return (
      <TableRow
        sx={{
          "&:hover ": {
            bgcolor: "transparent !important",
          },
        }}
      >
        <></>
      </TableRow>
    )
  }

  return (
    <>
      {data?.data.map((row: any, rowIndex: number) => (
        <TableRow
          sx={{
            border: "1px solid rgba(27, 156, 24, 1)",
            p: 0,
          }}
          key={rowIndex}
        >
          <TableCell
            sx={{
              p: 0,
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              display: "inline-flex",
              height: "100%",
              width: "100%",
            }}
          >
            <Box
              sx={{
                minWidth: "130px",
                minHeight: "110px",
                width: "100%",
                paddingTop: "20px",
                paddingBottom: "10px",
                paddingLeft: "20px",
                paddingRight: "10px",
                borderRadius: "4px",
              }}
            >
              <Box
                sx={{
                  height: "41px",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  gap: "5px",
                  display: "flex",
                }}
              >
                <Typography
                  sx={{
                    fontSize: 16,
                    fontWeight: "400",
                    wordWrap: "break-word",
                  }}
                >
                  {row.user.fullName}
                </Typography>
                <Typography
                  sx={{
                    color: "text.secondary",
                    fontSize: 14,
                    fontWeight: "400",
                    wordWrap: "break-word",
                  }}
                >
                  ID: {row.user.userId}
                </Typography>
              </Box>
            </Box>
          </TableCell>
          {startOfWeek.isBefore(endOfWeek) &&
            [...Array(endOfWeek.diff(startOfWeek, "days").valueOf() + 1)].map(
              (_, dayIndex) => {
                const currentDate = startOfWeek.add(dayIndex, "day")
                const cell = row.timeSlots.reduce(
                  (foundCell: any, timeSlot: any) => {
                    const timelineCell = timeSlot.timeline.find(
                      (timelineCell: any) =>
                        dayjs.utc(timelineCell.date).isSame(currentDate, "day"),
                    )
                    return foundCell || timelineCell
                  },
                  null,
                )

                return (
                  <TableCell
                    key={`${row.user.userId}_${dayIndex}`}
                    sx={{
                      width: "130px",
                      px: 0,
                      direction: "column",
                      verticalAlign: "top",
                      py: 0,
                    }}
                  >
                    {cell ? (
                      <Stack sx={{ pb: "10px" }}>
                        {cell.slots.map((item: any, slotIndex: number) => (
                          <Box
                            onClick={(e) => {
                              if (
                                keycloakInstance?.realmAccess?.roles?.some(
                                  (role) =>
                                    [
                                      "hiring-admin",
                                      "hiring-interviewer",
                                    ].includes(role),
                                )
                              ) {
                                dispatch(setSelectedTimeSlotState(item))
                                dispatch(setSelectedfullName(row.user.fullName))
                                dispatch(setSelecteduserId(row.user.userId))
                                handleClick(e)
                                dispatch(setSelectedDate(cell.date))
                              }
                            }}
                            key={slotIndex}
                            sx={{
                              py: "10px",
                              paddingLeft: "20px",
                              paddingRight: "10px",
                              background:
                                "linear-gradient(90deg, rgba(26.72, 156.19, 24.08, 0.10) 0%, rgba(26.72, 156.19, 24.08, 0) 100%)",
                              borderRadius: "4px",
                              borderLeft: "1px #1B9C18 solid",
                              justifyContent: "flex-start",
                              alignItems: "center",
                              display: "inline-flex",
                              height: "100px",
                              cursor:
                                keycloakInstance?.realmAccess?.roles?.some(
                                  (role) => ["hiring-admin"].includes(role),
                                )
                                  ? "pointer"
                                  : "default",
                              my: "5px",
                            }}
                          >
                            <Box
                              sx={{
                                flex: "1 1 0",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "flex-start",
                                gap: "5px",
                                display: "inline-flex",
                              }}
                            >
                              <Typography
                                style={{
                                  alignSelf: "stretch",
                                  color: "#171717",
                                  fontSize: 14,
                                  fontWeight: "400",
                                  wordWrap: "break-word",
                                }}
                              >
                                {dayjs.utc(item.startDate).format("HH:mm")} -{" "}
                                {dayjs.utc(item.endDate).format("HH:mm")}
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: "12px",
                                  fontWeight: "400",
                                  wordWrap: "break-word",
                                }}
                              >
                                {item.type.name}
                              </Typography>
                              {item.comment && (
                                <Typography
                                  sx={{
                                    fontSize: "12px",
                                    fontWeight: "400",
                                    wordWrap: "break-word",
                                    color: "text.secondary",
                                    whiteSpace: "pre",
                                  }}
                                >
                                  {item.comment}
                                </Typography>
                              )}
                              <Stack
                                direction={"row"}
                                spacing={"5px"}
                                alignItems={"center"}
                                justifyContent={"flex-start"}
                              >
                                <CircleIcon
                                  sx={{
                                    height: "10px",
                                    width: "10px",
                                    color:
                                      item?.usersCount < item?.limit &&
                                      (item?.usersCount !== 0 ||
                                        item?.usersCount === item?.limit)
                                        ? "rgba(255, 124, 3, 1)"
                                        : item?.usersCount === item?.limit
                                        ? "rgba(251, 55, 55, 1)"
                                        : item?.usersCount === 0
                                        ? "rgba(27, 156, 24, 1)"
                                        : null,
                                  }}
                                />
                                <Typography
                                  sx={{
                                    fontSize: "12px",
                                    fontWeight: "400",
                                  }}
                                >
                                  {item?.usersCount < item?.limit &&
                                    (item?.usersCount !== 0 ||
                                      item?.usersCount === item?.limit) &&
                                    `${item?.usersCount}/${item?.limit}`}
                                  {item?.usersCount === item?.limit && `Занято`}
                                  {item?.usersCount === 0 && `Свободно`}
                                </Typography>
                              </Stack>
                            </Box>
                          </Box>
                        ))}
                      </Stack>
                    ) : (
                      <> {/* Пустой фрагмент, если ячейка не найдена */} </>
                    )}
                  </TableCell>
                )
              },
            )}
        </TableRow>
      ))}
      {data?.length === 0 && <NoRowsOverlay />}
      {anchorEl && (
        <SelectedCellsPopup
          anchorEl={anchorEl}
          setAnchorEl={setAnchorEl}
          open={open}
          setOpen={setOpen}
        />
      )}
    </>
  )
}

export default TimeSlotsRow
